<div class="container simple">
  <lib-ad-sponsor-banner
    [entityId]="matchDetailViewService.data?.match?.id"
    [entityType]="entityType"
    [sponsors]="matchDetailViewService.sponsors"
    [lightHeading]="true">
  </lib-ad-sponsor-banner>
  <div
    *ngIf="!formationHome || formationHome?.id === -1 || !formationAway || formationAway?.id === -1; else showWholePitch">
    <div class="lineup-container"
         *ngIf="!isLoading() && (!formationHome || formationHome?.id === -1); else showHomePitch">
      <div class="header">
        <h2>Startelf</h2>
      </div>
      <div class="row">
        <div class="col-md-4 team">
          <img [src]="matchDetailViewService.data.homeTeam.getLogoImageUrl('small')" alt="Team Logo"/>
          <span><b>{{ matchDetailViewService.data.homeTeam.abbreviation }}</b></span>
        </div>
        <div class="col-md-4 formation">
          <div *ngIf="formationHome && formationHome.id !== -1">
            <span><b>Formation</b></span>
            <br>
            <span>{{ formationHome?.name }}</span>
          </div>
        </div>
        <!--<div class="col-md-4 trainer">
          <span><b>Trainer</b></span>
          <br>
          <span *ngIf="trainerHome?.firstname?.length > 0">{{trainerHome?.firstname[0]}}.&nbsp;</span>
          <span>{{trainerHome?.lastname}}</span>
        </div>-->
      </div>
      <ng-container *ngIf="getAllPlayersOfHomeTeam()?.length > 0; else noHomeLineup">
        <div class="main-col">
          <app-match-lineup-player *ngFor="let player of getAllPlayersOfHomeTeam()" class="player-wrapper"
                                   [player]="player" [isHome]="true"></app-match-lineup-player>
        </div>
      </ng-container>
      <ng-template #noHomeLineup>
        <div class="no-lineup">
          <span>Keine Aufstellung eingetragen</span>
        </div>
      </ng-template>
    </div>
    <ng-template #showHomePitch>
      <div class="lineup-container">
        <div class="header">
          <h2>Startelf</h2>
        </div>
        <div class="row">
          <div class="col-md-4 team">
            <img [src]="matchDetailViewService.data.homeTeam.getLogoImageUrl('small')" alt="Wappen"/>
            <span><b>{{ matchDetailViewService.data.homeTeam.abbreviation }}</b></span>
          </div>
          <div class="col-md-4 formation">
            <div *ngIf="formationHome && formationHome?.id !== -1">
              <span><b>Formation</b></span>
              <br>
              <span>{{ formationHome?.name }}</span>
            </div>
          </div>
          <!--<div class="col-md-4 trainer">
            <span><b>Trainer</b></span>
            <br>
            <span *ngIf="trainerHome?.firstname?.length > 0">{{trainerHome?.firstname[0]}}.&nbsp;</span>
            <span>{{trainerHome?.lastname}}</span>
          </div>-->

        </div>
        <ng-container *ngIf="getAllPlayersOfHomeTeam()?.length > 0; else noHomeLineup">
          <div class="main-col-pitch">
            <div class="penalty-area"></div>
            <div class="center-circle"></div>
            <app-match-lineup-player *ngFor="let player of getAllPlayersOfHomeTeam(); let i = index"
                                     [ngClass]="formationHome?.positions[i]" [player]="player" [hasFormation]="true"
                                     [isHome]="true"></app-match-lineup-player>
          </div>
        </ng-container>
        <ng-template #noHomeLineup>
          <div class="no-lineup">
            <span>Keine Aufstellung eingetragen</span>
          </div>
        </ng-template>
      </div>
    </ng-template>

    <div class="lineup-container"
         *ngIf="!isLoading() && (!formationAway || formationAway?.id === -1); else showAwayPitch">
      <div class="header">
        <h2>Startelf</h2>
      </div>
      <div class="row">
        <div class="col-md-4 team">
          <img [src]="matchDetailViewService.data.awayTeam.getLogoImageUrl('small')" alt="Wappen"/>
          <span><b>{{ matchDetailViewService.data.awayTeam.abbreviation }}</b></span>
        </div>
        <div class="col-md-4 formation">
          <div *ngIf="formationAway && formationAway.id !== -1">
            <span><b>Formation</b></span>
            <br>
            <span>{{ formationAway?.name }}</span>
          </div>
        </div>
        <!--<div class="col-md-4 trainer">
          <span><b>Trainer</b></span>
          <br>
          <span *ngIf="trainerAway?.firstname?.length > 0">{{trainerAway?.firstname[0]}}.&nbsp;</span>
          <span>{{trainerAway?.lastname}}</span>
        </div>-->
      </div>
      <ng-container *ngIf="getAllPlayersOfAwayTeam()?.length > 0; else noAwayLineup">
        <div class="main-col">
          <app-match-lineup-player *ngFor="let player of getAllPlayersOfAwayTeam()" class="player-wrapper"
                                   [player]="player" [isAway]="true"></app-match-lineup-player>
        </div>
      </ng-container>
      <ng-template #noAwayLineup>
        <div class="no-lineup">
          <span>Keine Aufstellung eingetragen</span>
        </div>
      </ng-template>
    </div>
    <ng-template #showAwayPitch>
      <div class="lineup-container">
        <div class="header">
          <h2>Startelf</h2>
        </div>
        <div class="row">
          <div class="col-md-4 team">
            <img [src]="matchDetailViewService.data.awayTeam.getLogoImageUrl('small')" alt="Wappen"/>
            <span><b>{{ matchDetailViewService.data.awayTeam.abbreviation }}</b></span>
          </div>
          <div class="col-md-4 formation">
            <div *ngIf="formationAway && formationAway.id !== -1">
              <span><b>Formation</b></span>
              <br>
              <span>{{ formationAway?.name }}</span>
            </div>
          </div>
          <!--<div class="col-md-4 trainer">
            <span><b>Trainer</b></span>
            <br>
            <span *ngIf="trainerAway?.firstname?.length > 0">{{trainerAway?.firstname[0]}}.&nbsp;</span>
            <span>{{trainerAway?.lastname}}</span>
          </div>-->
        </div>
        <ng-container *ngIf="getAllPlayersOfAwayTeam()?.length > 0; else noAwayLineup">
          <div class="main-col-pitch rotate-pitch">
            <div class="penalty-area"></div>
            <div class="center-circle"></div>
            <app-match-lineup-player *ngFor="let player of getAllPlayersOfAwayTeam(); let i = index"
                                     class="rotate-player" [ngClass]="formationAway?.positions[i]" [player]="player"
                                     [hasFormation]="true" [isAway]="true"></app-match-lineup-player>
          </div>
        </ng-container>
        <ng-template #noAwayLineup>
          <div class="no-lineup">
            <span>Keine Aufstellung eingetragen</span>
          </div>
        </ng-template>
      </div>
    </ng-template>
  </div>
  <ng-template #showWholePitch>
    <div class="lineup-container">
      <div class="header">
        <h2>Startelf</h2>
      </div>
      <div class="row">
        <div class="col-md-4 team">
          <img [src]="matchDetailViewService.data.homeTeam.getLogoImageUrl('small')" alt="Wappen"/>
          <span><b>{{ matchDetailViewService.data.homeTeam.abbreviation }}</b></span>
        </div>
        <div class="col-md-4 formation">
          <div *ngIf="formationHome && formationHome.id !== -1">
            <span><b>Formation</b></span>
            <br>
            <span>{{ formationHome?.name }}</span>
          </div>
        </div>
        <!--<div class="col-md-4 trainer">
          <span><b>Trainer</b></span>
          <br>
          <span *ngIf="trainerHome?.firstname?.length > 0">{{trainerHome?.firstname[0]}}.&nbsp;</span>
          <span>{{trainerHome?.lastname}}</span>
        </div>-->
      </div>
      <ng-container *ngIf="getAllPlayersOfHomeTeam()?.length > 0; else noHomeLineup">
        <div class="main-col-pitch">
          <div class="penalty-area"></div>
          <div class="center-circle"></div>
          <app-match-lineup-player *ngFor="let player of getAllPlayersOfHomeTeam(); let i = index"
                                   [ngClass]="formationHome?.positions[i]" [player]="player" [hasFormation]="true"
                                   [isHome]="true"></app-match-lineup-player>
        </div>
      </ng-container>
      <ng-template #noHomeLineup>
        <div class="no-lineup">
          <span>Keine Aufstellung eingetragen</span>
        </div>
      </ng-template>
      <ng-container *ngIf="getAllPlayersOfHomeTeam()?.length > 0; else noAwayLineup">
        <div class="main-col-pitch rotate-pitch">
          <div class="penalty-area"></div>
          <div class="center-circle"></div>
          <app-match-lineup-player *ngFor="let player of getAllPlayersOfAwayTeam(); let i = index" class="rotate-player"
                                   [ngClass]="formationAway?.positions[i]" [player]="player" [hasFormation]="true"
                                   [isAway]="true"></app-match-lineup-player>
        </div>
      </ng-container>
      <ng-template #noAwayLineup>
        <div class="no-lineup">
          <span>Keine Aufstellung eingetragen</span>
        </div>
      </ng-template>
      <div class="row">
        <div class="col-md-4 team">
          <img [src]="matchDetailViewService.data.awayTeam.getLogoImageUrl('small')" alt="Wappen"/>
          <span><b>{{ matchDetailViewService.data.awayTeam.abbreviation }}</b></span>
        </div>
        <div class="col-md-4 formation">
          <div *ngIf="formationAway && formationAway.id !== -1">
            <span><b>Formation</b></span>
            <br>
            <span>{{ formationAway?.name }}</span>
          </div>
        </div>
        <!--<div class="col-md-4 trainer">
          <span><b>Trainer</b></span>
          <br>
          <span *ngIf="trainerAway?.firstname?.length > 0">{{trainerAway?.firstname[0]}}.&nbsp;</span>
          <span>{{trainerAway?.lastname}}</span>
        </div>-->
      </div>
    </div>
  </ng-template>
  <lib-ad class="mt-2 mb-2"></lib-ad>

  <!--  Ersatzbank  -->

  <div class="lineup-container reserve" *ngIf="!isLoading()">
    <div class="header">
      <h2>Ersatzbank</h2>
    </div>
    <div class="left-col">
      <div class="team">
        <img [src]="matchDetailViewService.data.homeTeam.getLogoImageUrl('small')" alt="Wappen"/>
        <span>{{ matchDetailViewService.data.homeTeam.abbreviation }}</span>
      </div>
      <ng-container *ngIf="getReservePlayersOfHomeTeam()?.length > 0; else noHomeLineup">
        <app-match-lineup-player *ngFor="let player of getReservePlayersOfHomeTeam()" [player]="player" [isHome]="true"
                                 [noBorder]="true"></app-match-lineup-player>
      </ng-container>
      <ng-template #noHomeLineup>
        <div class="no-lineup">
          <span>Keine Ersatzspieler eingetragen</span>
        </div>
      </ng-template>
    </div>
    <div class="right-col">
      <div class="team">
        <span>{{ matchDetailViewService.data.awayTeam.abbreviation }}</span>
        <img [src]="matchDetailViewService.data.awayTeam.getLogoImageUrl('small')" alt="Wappen"/>
      </div>
      <ng-container *ngIf="getReservePlayersOfAwayTeam()?.length > 0; else noAwayLineup">
        <app-match-lineup-player *ngFor="let player of getReservePlayersOfAwayTeam()" [player]="player" [isAway]="true"
                                 [isSubstitute]="true" [noBorder]="true"></app-match-lineup-player>
      </ng-container>
      <ng-template #noAwayLineup>
        <div class="no-lineup">
          <span>Keine Ersatzspieler eingetragen</span>
        </div>
      </ng-template>
    </div>
  </div>
</div>
